export default {
  hi_im_neela: 'Bonjour, je suis Neela,',
  aareons_virtual: 'votre assistante digitale.',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  polish: 'Polska',
  media: 'Médias',
  media_link: 'https://neela.aareon.fr/media',
  contact: 'Contact',
  contact_link: 'https://neela.aareon.fr/contact',
  privacy: 'Déclaration de confidentialité',
  privacy_link:
    'https://www.aareon.fr/Declaration_de_confidentialite.90388.html',
  terms_of_use: "Conditions générales d'utilisation",
  terms_of_use_link:
    'https://www.aareon.fr/Conditions_generales_d_utilisation.250752.html',
  legal_notice: 'Mentions légales',
  legal_notice_link: 'https://neela.aareon.fr/legal',
  show_system_messages: 'Afficher les messages du système',
  dont_show_system_messages: 'Masquer les messages système',
  logged_in: 'Le locataire est authentifié',
  logged_out: 'Utilisateur anonyme',
  button_switch_locale: 'Changer langue',
  button_tooltip_activate_voice_recognition: 'Activer la reconnaissance vocale',
  date_input: 'Choisir date',
  choose_two_dates: 'Choisissez deux dates',
  date_range: 'Plage de dates',
  from: 'de',
  to: 'à',
  avatar: 'Avatar',
  exit: 'Fermer',
  new: 'Nouveau',
  back: 'Retour',
  suggestions: 'Suggestions',
  senton: 'Envoyé le',
  message_placeholder: 'Tapez votre message ici...',
  comment_placeholder: 'Entrez votre commentaire ici...',
  file_max_upload_text: 'Un maximum de 20 fichiers peut être téléchargé',
  message_button_label: 'Envoyer',
  please_confirm: 'Veuillez confirmer',
  no: 'Non',
  yes: 'Oui',
  modal_delete_session: 'Supprimer session',
  modal_delete_session_notification:
    "Si vous fermez la fenêtre, votre session sera également supprimée. <br>Êtes-vous d'accord ?",
  template_contact_time: 'Quand pouvons-nous vous contacter ?',
  template_pause:
    "Votre séance a été interrompue. Un membre de notre personnel de soutien s'occupera de votre demande dans les plus brefs délais.",
  template_continue_after_pause:
    "Votre session s'est poursuivie. Vous pouvez maintenant continuer à écrire avec notre agent virtuel.",
  button_apply: 'Appliquer',
  button_cancel: 'Suspendre',
  none: 'Aucun',
  book_appointment: 'Prendre rendez-vous',
  address_input: "Entrée d'adresse",
  privacy_policy: 'politique de confidentialité',
  data_processing: 'Traitement des données',
  data_processing_notification_before_link:
    'Pour utiliser ce service de chat, il est nécessaire que vous acceptiez la ',
  data_processing_notification_after_link: '.',
  button_accept: 'Accepter',
  select_date: 'Choisir date',
  rate_conversation: 'Comment évalueriez-vous cette conversation?',
  new_ticket_question:
    'Y a-t-il autre chose que je puisse faire pour vous aider ?',
  thank_you:
    "Merci pour votre soutien. Vos commentaires m'aident à m'améliorer constamment.",
  goodbye: 'À bientôt',
  start_new: 'Commencer nouvelle conversation',
  operator_entered_the_chat: 'Operator entered the chat',
  operator_left_the_chat: 'Operator has left the chat',
  bg_image: process.env.VUE_APP_FR_BG,
  expand_quickreplies: 'Plus',
  collapse_quickreplies: 'Moins',
  login: 'Connexion',
  logout: 'Déconnexion',
  close: 'Fermer',
  maximize: 'Maximize',
  minimize: 'Minimize',
  feedback_helpful: "Cette réponse m'a aidé",
  feedback_not_helpful: "Cette réponse ne m'a pas aidé",
  chatProtocol: 'ProtocoleDeChat',
  showMore: 'Montrer plus',
  showLess: 'Montrer moins',
  uploadTooltip: 'Télécharger le fichier',
  uploadFilesTooltip: 'Télécharger des fichiers',
  pdfDownloadTooltip: 'Téléchargement de la conversation',
  feedbackDescription: 'Commentaires pour nous',
  feedbackSubtitle: {
    description:
      "Vous pouvez nous envoyer ici des suggestions, des propositions et des demandes d'ordre général.",
    note: 'Veuillez noter que nous ne pouvons pas y répondre.',
    hint:
      "Toutes les autres préoccupations qui concernent spécifiquement votre location ou la recherche d'un appartement peuvent nous être décrites dans le chat."
  },
  feedbackPlaceholder: 'Entrez votre message ici...',
  sendFeedback: 'Envoyer',
  giveFeedback: 'Commentaires pour nous',
  feedbackSubmittedSuccessfully: 'Votre commentaire a été soumis avec succès',
  thanks: 'Merci'
}
